
import "./styles.css";
import "../styles.css";
import Drawer from "antd/lib/drawer";
import { SunkhronosCompany } from '../../../../utils/types/applications/sunkhronosTypes';
import FAIcon from '../../../common/FAIcon/FAIcon';
import EditCompanyContent from './EditCompanyContent';
import { Dayjs } from "dayjs";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";

interface Props {
    open: boolean;
    onCancel: (companies?: SunkhronosCompany) => void;
    selectedCompany?: SunkhronosCompany;
    selectedDate: Dayjs;
}

const EditCompanyDrawer = (props: Props) => {
    const reset = useCallback((company?: SunkhronosCompany) => {
        props.onCancel(company);
    }, [props]);

    return (
        <Drawer
            open={props.open}
            title={<><FAIcon prefix='fad' name='industry-windows' /> <>{`Editing company: ${props.selectedCompany?.name}`}</></>}
            closable={false}
            width={500}
            maskClosable={false}
            destroyOnClose={true}
        >
            <EditCompanyContent
                cancelText={<FormattedMessage defaultMessage={'Cancel'} />}
                selectedCompany={props.selectedCompany}
                selectedDate={props.selectedDate}
                onCancel={reset}
            />
        </Drawer >
    );
};

export default EditCompanyDrawer;